import apiSlice from "../api/apiSlice";

export const coefficientsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    /* GET */
    getCoefficientsByCommunityIdPagination: builder.query({
      query: ({ limit, page, date, time, meterId, communityId, sortColumn, sortDirection }) => ({
        url:
          `/communities/${communityId}/coefficients/fixed/pagination?` +
          `limit=${limit}&` +
          `offset=${page * limit}` +
          `${date ? `&date=${date}` : ""}` +
          `${time ? `&time=${time}` : ""}` +
          `${meterId ? `&meter_id=${meterId}` : ""}` +
          `${sortDirection ? `&sort_direction=${sortDirection}` : ""}` +
          `${sortColumn ? `&sort_column=${sortColumn}` : ""}`,
        method: "GET",
      }),
      providesTags: () => [{ type: "Coefficient", id: "LIST" }],
    }),
    /* POST */
    addNewCoefficients: builder.mutation({
      query: ({ file, communityId }) => {
        const formData = new FormData();
        formData.append("file_upload", file, file.name);
        return {
          url: `/communities/${communityId}/coefficients/fixed/file_upload`,
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "Coefficient", id: "LIST" }],
    }),
  }),
});

export const { useGetCoefficientsByCommunityIdPaginationQuery, useAddNewCoefficientsMutation } =
  coefficientsApiSlice;
